import React from 'react';
import HeroSlider from "../component/Slider";
import Facility from "../component/Facility";
import {Link} from 'react-router-dom';
import VisaType from "../component/VisaType";
import VisaInstruction from "../component/VisaInstruction";
import OurSuccess from "../component/OurSuccess";
import Partner from "../component/Partner";
import BLogCardHome from "../component/BlogCardHome";
import Testimonial from "../component/Testimonial";
import NewsLetter from "../component/NewsLetter";
import FaqHome from "../component/FaqHome";
import FreeConsultation from "../component/FreeConsultation";

const Home = () => {
    return (
        <main>
            <main className="main">
                <HeroSlider />
                <FreeConsultation />

                <Facility />

                <VisaType />

                <OurSuccess />

                <div className="country-area">
                    <div className="country-bg" style={{backgroundImage:'url(assets/img/country/bg.jpg)'}}></div>
                    <div className="container pt-80">
                        <div className="row">
                            <div className="col-lg-6 mx-auto">
                                <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s">
                                    <h2 className="site-title text-white"><i className="far fa-passport"></i> ভিসা ও ইমিগ্রেশন নির্দেশনা</h2>
                                </div>
                            </div>
                        </div>
                        <div className="country-wrap">
                            <VisaInstruction />
                            <div className="text-center my-2">
                                <Link className={'btn btn-success my-2'} to={'/contact-us'}>আরো জানতে ক্লিক করুন <i className={'fa fa-plus'}></i></Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Testimonial */}

                <Testimonial />

                {/* Partner */}

                <Partner />

                {/* FAQ */}

                <FaqHome />

                <BLogCardHome />

                <div className="cta-area pb-100">
                    <div className="container">
                        <div className="cta-wrap">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="cta-img">
                                        <img src="assets/img/service/single.jpg" alt=""/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="cta-content">
                                        <h1 className={'fw-bold'}>নিউজ আপডেট</h1>
                                        <p>সর্বশেষ খবর পেতে আপনার ইমেইল অথবা ফোন নম্বর দিয়ে সাবস্ক্রাইব করুন!</p>
                                        <NewsLetter />
                                        <Link className="theme-btn2 text-decoration-none" to={'/contact-us'}>Contact Now <i className="fas fa-circle-arrow-right"></i></Link>
                                        <div className="shape">
                                            <img src="assets/img/shape/02.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </main>
    );
}

export default Home;